import React from 'react';
import { Typography, Link, Button, Box } from '@material-ui/core';
import Modal from '../Modal/Modal';
import {setModalReset} from "../../actions/app";
import {connect} from 'react-redux';

const LoginErrorModal = ({setModalReset}) => {
    return (
        <Modal
            maxWidth="sm"
            id='login-error-modal'
            title="We are sorry"
        >
            <Typography gutterBottom>There was an error logging in. Please try again or contact <Link target="_blank" rel="noopener noreferrer" href="https://giftyasupport.zendesk.com/hc/en-us">customer service</Link>.</Typography>

            <Box maxWidth={200} ml="auto" mt={5}>
                <Button onClick={() => {setModalReset()}} variant="contained" fullWidth color="secondary">Close</Button>
            </Box>
        </Modal>
    )
};

export default connect(
    () => ({}),
    {
        setModalReset
    }
)(LoginErrorModal);